<template>
  <div
    v-if="(isAuth && this.$route.name != 'Login' && this.$route.name != 'BasicInfo' && this.$route.name != 'ExpireLink' && this.$route.name != 'ForgotPassword' && this.$route.name != 'ResetPassword' && this.$route.name != 'update-profile') || this.$route.name == 'agencyPublicProfile' || this.$route.name == 'freelancerProfile'"
    class="fixed top-0 flex items-center justify-between w-full px-4 transition-all ease-in bg-white shadow-sm duration-600 navbar-main sm:px-6">
    <!-- Logo -->
    <div class="h-full mr-4">
      <router-link :to="($store.state.accountType=='freelancer')?'/freelancer':($store.state.accountType == 'client')?'/client':'/agency/search'">
        <WebLogo class="mt-4 lg:w-full lg:h-full" />
      </router-link>
    </div>

    <!-- Mobile Version -->
    <div class="block md:hidden lg:hidden mobile-search" v-if="isAuth">
      <button @click="toggleMobileSearch" class="p-2 searchbtn">
        <SearchIcon class="w-6 h-6 text-gray-600" />
      </button>
      <div v-if="isMobileSearchVisible" class="absolute left-0 w-full mt-2 inputwrapper ">
        <form class="header-search-wr mobile" @submit.prevent="openSearch('mobile','')" :class="{ typing: searchValue.length > 0, focused: this.$store.state.searchData.length > 0 }">
          <SearchIcon class="absolute" />
          <input v-model="searchValue" type="text" name="search" id="search" :placeholder="placeholder_label" @input="getSearchData" 
              @keydown.enter="handleEnterKey('mobile')"   @focus="getSearchData"   @blur="handleBlur"
              autocomplete="off" 
              autocorrect="off" 
              autocapitalize="off" 
              spellcheck="false"
              aria-autocomplete="none"
          />
           <span 
            v-if="searchValue" 
            @click="clearSearch" 
            class="reset-header-search main-header"
          >
            ✖
          </span>
          <strong class="profile-type-for-search">
            {{search_label}}
          </strong> 
          <template v-if="filteredSearchData.length > 0">
            <div class="auto-fill-data-wr">
              <ul>
                <li v-for="(serach,index) in filteredSearchData"  :key="index"   @click="gotoSearchPage(serach,'mobile')"  >
                    <svg  v-if="serach.search_type==1" xmlns="http://www.w3.org/2000/svg" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" xmlns:xlink="http://www.w3.org/1999/xlink" height="21px" version="1.1" viewBox="0 0 20 21" width="20px"><title/><desc/><defs/><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#000000" id="Core" opacity="0.9" transform="translate(-464.000000, -254.000000)"><g id="history" transform="translate(464.000000, 254.500000)"><path d="M10.5,0 C7,0 3.9,1.9 2.3,4.8 L0,2.5 L0,9 L6.5,9 L3.7,6.2 C5,3.7 7.5,2 10.5,2 C14.6,2 18,5.4 18,9.5 C18,13.6 14.6,17 10.5,17 C7.2,17 4.5,14.9 3.4,12 L1.3,12 C2.4,16 6.1,19 10.5,19 C15.8,19 20,14.7 20,9.5 C20,4.3 15.7,0 10.5,0 L10.5,0 Z M9,5 L9,10.1 L13.7,12.9 L14.5,11.6 L10.5,9.2 L10.5,5 L9,5 L9,5 Z" id="Shape"/></g></g></g></svg>
                    <SearchIcon v-if="serach.search_type==2" class="absolute" />{{ serach.search_word }} 
                </li>
                
              </ul>
            </div>
          </template>
        </form>
      </div>
    </div>

    <!-- Desktop Version -->
    <div class="hidden md:block lg:block">
      <div class="relative flex justify-start ml-4 rounded-sm" v-if="isAuth">
        <form class="header-search-wr" @submit.prevent="openSearch('web','')" :class="{ typing: searchValue.length > 0, focused: this.$store.state.searchData.length > 0 }">
          <SearchIcon class="absolute" />
          <input v-model="searchValue" type="text" name="search" id="search" :placeholder="placeholder_label" @input="getSearchData"
            @keydown.enter="handleEnterKey('web')"   @focus="getSearchData" @blur="handleBlur"
            autocomplete="off" 
            autocorrect="off" 
            autocapitalize="off" 
            spellcheck="false"
            aria-autocomplete="none"
          />
           <span 
            v-if="searchValue" 
            @click="clearSearch"
            class="reset-header-search main-header"
          >
            ✖
          </span>
          <strong class="profile-type-for-search">
            {{search_label}}
          </strong>
          <template v-if="filteredSearchData.length > 0">
            <div class="auto-fill-data-wr">
              <ul>
                <li v-for="(serach,index) in filteredSearchData"  :key="index"  @click="gotoSearchPage(serach,'web')" >
                  <svg v-if="serach.search_type==1" xmlns="http://www.w3.org/2000/svg" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" xmlns:xlink="http://www.w3.org/1999/xlink" height="21px" version="1.1" viewBox="0 0 20 21" width="20px"><title/><desc/><defs/><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#000000" id="Core" opacity="0.9" transform="translate(-464.000000, -254.000000)"><g id="history" transform="translate(464.000000, 254.500000)"><path d="M10.5,0 C7,0 3.9,1.9 2.3,4.8 L0,2.5 L0,9 L6.5,9 L3.7,6.2 C5,3.7 7.5,2 10.5,2 C14.6,2 18,5.4 18,9.5 C18,13.6 14.6,17 10.5,17 C7.2,17 4.5,14.9 3.4,12 L1.3,12 C2.4,16 6.1,19 10.5,19 C15.8,19 20,14.7 20,9.5 C20,4.3 15.7,0 10.5,0 L10.5,0 Z M9,5 L9,10.1 L13.7,12.9 L14.5,11.6 L10.5,9.2 L10.5,5 L9,5 L9,5 Z" id="Shape"/></g></g></g></svg>
                  <SearchIcon v-if="serach.search_type==2" class="absolute" />{{ serach.search_word }}
                </li>
              </ul>
            </div>
          </template>
        </form>
      </div>
    </div>

    <WebMenuBar ></WebMenuBar>

    <!-- Login& & SignUp Resources -->
    <div class="hidden sm:hidden md:block lg:block">
      <div class="flex items-center justify-end" v-if="!isAuth">
        <label v-if="$route.path === '/login'"
          class="flex justify-end mr-5 text-sm font-medium text-gray-500 no-underline transition-all duration-300 ease-in-out w-96">
          New to Qapin ?
        </label>

        <label v-if="$route.path === '/sign-up'"
          class="flex justify-end mr-5 text-sm font-medium text-gray-500 no-underline transition-all duration-300 ease-in-out w-96">
          Already a member?
        </label>

        <router-link v-if="$route.path === '/forgot-password' || $route.path === '/reset-link'
          " to="/login"
          class="flex justify-end p-2 text-sm font-medium text-gray-500 no-underline transition-all duration-300 ease-in-out border-white border-solid rounded-md cursor-pointer hoveer:rounded-md hover:bg-gray-100 hover:border hover:border-primary-500 hover:shadow-lg hover:text-primary-500 hovr:border-solid w-max">
          Back To Login
        </router-link>

        <div class="">
          <router-link to="/sign-up" type="button" v-if="$route.path === '/login'"
            class="w-32 px-4 py-2 text-sm font-semibold text-center text-gray-900 no-underline transition-all duration-300 ease-in border border-gray-400 rounded-md shadow-sm cursor-pointer flex-inline hover:text-primary-500 hover:bg-gray-200">
            Sign Up
          </router-link>

          <router-link to="/login" type="button" v-if="$route.path === '/sign-up'"
            class="px-4 py-2 text-sm font-semibold text-gray-900 no-underline transition-all duration-300 ease-in border border-gray-400 rounded-md shadow-sm cursor-pointer hover:text-primary-500 hover:bg-gray-200">
            Sign In
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var that = '';
import { SearchIcon } from "@vue-hero-icons/solid";
import WebLogo from "./icons/WebLogo.vue";
import WebMenuBar from "../components/menu-bar/web-menu-bar.vue";
import { mapGetters, mapActions,mapState } from "vuex";

export default {
  components: {
    SearchIcon,
    WebLogo,
    WebMenuBar,
  },

  data() {
    return {
      loadAPIonload       : false,
      isOpen              : false,
      isAccount           : false,
      isMessage           : false,
      isNotification      : false,
      currentUser         : null,
      isAuth              : null,
      searchValue         : '',
      search_label        : this.$store.state.accountType != 'freelancer'?'Talent':'Jobs',
      placeholder_label   : this.$store.state.accountType == 'client'?'Find freelancers and agencies':'Search jobs posted by clients',
      isMobileSearchVisible: false, // Controls the visibility of the search input on mobile
      mobileSearchValue: '', // Search value for mobile
      desktopSearchValue: '', // Search value for desktop
      searchData          : [],
      enterKeyPressCount  : 0,
    };
  },

  computed: {
    filteredSearchData() {
      return this.$store.state.searchData.filter(
        (search) => search.search_word && search.search_word.trim()
      );
    },
    ...mapGetters(["getcurrentUrl","getstopBodyScroll","getUserOnlinestatus"]),
    ...mapGetters("global",["getmRequestData"]),
    ...mapState(['searchKey']),  
  },

  async mounted() {
    that = this;
    that.getData();
    that.updateChatroomLoader({params : true})
  },
  watch: {
    searchKey(newValue, oldValue) {
      console.log(`Search value changed from ${oldValue} to ${newValue}`);
      this.searchValue  = newValue.search_word;
    },
    // this fun is for to check current page url 
    async getcurrentUrl(){
      console.log('getcurrentUrl',this.getcurrentUrl)
      console.log('this.$store.state.listAccount',this.$store.state.listAccount);
      
      // alert(this.$store.state.accountType);
      that.updateChatroomLoader({params : true})
      if(this.isAuth != null && (this.getcurrentUrl == 'chat' || this.getcurrentUrl == 'contractDetails' || this.getcurrentUrl == 'freelancercontractDetail' || this.getcurrentUrl == 'agencycontractDetail' || this.getcurrentUrl == 'messageSideBar' || this.getcurrentUrl == 'messageDetails')){
        await this.EmptyMessageData({params : []});
        if(this.getcurrentUrl != 'chat'){
          this.EmptyRoomData({params : []});
        }
        if(this.$store.state.accountType == 'freelancer'){
          await this.UpdateRequestRoomData({params:{'user_id':this.$store.state.currentUserData.login_master_id,'status':1,'userType': this.$store.state.accountType,'title': '','sort': 'DESC'}});
          await this.callChatRoomApi('getchatroom',{'request_type':'getchatroom','user_id':this.$store.state.currentUserData.login_master_id,'status':1,'userType': this.$store.state.accountType,'title': '','sort': 'DESC'});
        }
        else if(this.$store.state.accountType == 'client' && this.$store.state.listAccount.user != null && this.$store.state.listAccount.user != ''  && this.$store.state.currentUserData.login_master_id == this.$store.state.listAccount.user.user_id){
          await this.UpdateRequestRoomData({params:{'client_id':this.$store.state.currentUserData.login_master_id,'status':1,'userType': this.$store.state.accountType,'title': '','sort': 'DESC'}});
          await this.callChatRoomApi('getchatroom',{'request_type':'getchatroom','client_id':this.$store.state.currentUserData.login_master_id,'status':1,'userType': this.$store.state.accountType,'title': '','sort': 'DESC'});
        }
        else if(this.$store.state.accountType == 'client' && this.$store.state.listAccount.user != null && this.$store.state.listAccount.user != '' && this.$store.state.currentUserData.login_master_id != this.$store.state.listAccount.user.user_id ){
          // alert('else-if');
          await this.UpdateInvitationRequestRoomData({params:{'user_id':this.$store.state.currentUserData.permission.user_id,'member_permission_id': this.$store.state.currentUserData.permission.members_permission_id,'title': '','sort': 'DESC'}});
          await this.callChatRoomApi('getChatInvitation',{'request_type':'getChatInvitation','user_id':this.$store.state.currentUserData.permission.user_id,'member_permission_id': this.$store.state.currentUserData.permission.members_permission_id,'title': '','sort': 'DESC'});
        }
        else if(this.$store.state.accountType == 'client' && this.$store.state.currentUserData.permission.user_id == this.$store.state.listAccount.qp_user.user_id){
          await this.UpdateInvitationRequestRoomData({params:{'user_id':this.$store.state.currentUserData.permission.user_id,'member_permission_id': this.$store.state.currentUserData.permission.members_permission_id,'title': '','sort': 'DESC'}});
          await this.callChatRoomApi('getChatInvitation',{'request_type':'getChatInvitation','user_id':this.$store.state.currentUserData.permission.user_id,'member_permission_id': this.$store.state.currentUserData.permission.members_permission_id,'title': '','sort': 'DESC'});
        }
        else if(this.$store.state.accountType == 'agency' && this.$store.state.currentUserData.login_master_id == this.$store.state.listAccount.company.login_master_id){
          await this.UpdateRequestRoomData({params:{'agency_id':this.$store.state.currentUserData.login_master_id,'status':1,'userType': this.$store.state.accountType,'title': '','sort': 'DESC'}});
          await this.callChatRoomApi('getchatroom',{'request_type':'getchatroom','agency_id':this.$store.state.currentUserData.login_master_id,'status':1,'userType': this.$store.state.accountType,'title': '','sort': 'DESC'});
        }
        else if(this.$store.state.accountType == 'agency' && this.$store.state.currentUserData.login_master_id != this.$store.state.listAccount.company.login_master_id){
          await this.UpdateInvitationRequestRoomData({params:{'user_id':this.$store.state.currentUserData.permission.user_id,'member_permission_id': this.$store.state.currentUserData.permission.members_permission_id,'title': this.search,'sort': this.sort}});
          await this.callChatRoomApi('getChatInvitation',{'request_type':'getChatInvitation','user_id':this.$store.state.currentUserData.permission.user_id,'member_permission_id': this.$store.state.currentUserData.permission.members_permission_id,'title': this.search,'sort': this.sort});
        }
        await this.callChatData();
      }
    },
    // this fun is for to stop body scroll
    getstopBodyScroll(){
      var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
      if(this.getstopBodyScroll == true){
        root.setAttribute( 'class', 'htmlClass' );
      }else{
        root.setAttribute( 'class', '');
      }
    },
    // this fun is for to check user online status 
    getUserOnlinestatus(){
      that.updateOnlineOfflineStatus();
    },
    
  },
  methods: {
    ...mapActions(["genericAPIPOSTRequest","UpdateBodyScrollRole","genericAPIPOSTForNodeRequest"]),
    ...mapActions("global",["fetchChatfromSocket","UpdateRequestRoomData","UpdateInvitationRequestRoomData","fetchChatRoomData","UpdateMessageRequestData","fetchChatData","EmptyMessageData","EmptyRoomData","fetchfromSocketChatRoomData","updateChatroomLoader"]),
    // this fun is for to check all condition on page load
    async clearSearch() {
      this.searchValue = ''; // Clear local input
      this.$store.dispatch("searchValue",''); // Clear Vuex state
    },
    async gotoSearchPage(search,device){ 
      this.$store.dispatch("searchData", []);
      this.searchValue = search.search_word;
      this.openSearch(device,search);
    },
    async getData(){
      that.checkwindowResolution();
      that.$store.dispatch("updateSingleInvoiceData", '');
      that.isAuth = that.$store.state.currentUserData.token;
      console.log('this.$route.name',that.$route.name)
      console.log('that.isAuth',that.isAuth)
      if (that.$route.name == "ExpireLink") {
        that.isAuth = null;
      }
      if(that.isAuth != null){
        // that.updateOnlineOfflineStatus();
        that.getOwnerDetail();
        that.getCompanyCount()
        that.getCurrentUserDetails()
        that.UpdateMessageRequestData({params:{'chat_room_id': '','start_limit': 0,'end_limit': 10,'cycle': '','lastId': '','firstId': '',}})
        that.EmptyRoomData({params : []})
        that.EmptyMessageData({params : []})
      }
      if(that.isAuth != null  && !that.loadAPIonload && (that.getcurrentUrl == 'chat'|| that.getcurrentUrl == 'contractDetails' || that.getcurrentUrl == 'freelancercontractDetail' || that.getcurrentUrl == 'agencycontractDetail' || that.getcurrentUrl == 'messageDetails') && (that.getcurrentUrl == 'chat'|| that.$route.name == 'contractDetails' || that.$route.name == 'freelancercontractDetail' || that.$route.name == 'agencycontractDetail' || that.$route.name == 'messageDetails')){
        // alert('asdasd'); 
      // if(that.isAuth != null  && !that.loadAPIonload && (that.getcurrentUrl == 'chat'|| that.getcurrentUrl == 'contractDetails' || that.getcurrentUrl == 'freelancercontractDetail' || that.getcurrentUrl == 'agencycontractDetail' || that.getcurrentUrl == 'messageDetails') && (that.$route.name == 'chat'|| that.$route.name == 'contractDetails' || that.$route.name == 'freelancercontractDetail' || that.$route.name == 'agencycontractDetail' || that.$route.name == 'messageDetails')){
        that.loadAPIonload = true;
        if(that.$store.state.accountType == 'freelancer'){
          await that.UpdateRequestRoomData({params:{'user_id':that.$store.state.currentUserData.login_master_id,'status':1,'userType': that.$store.state.accountType,'title': '','sort': 'DESC'}}).then(()=>{
            that.callChatRoomApi('getchatroom',{'request_type':'getchatroom','user_id':that.$store.state.currentUserData.login_master_id,'status':1,'userType': that.$store.state.accountType,'title': '','sort': 'DESC'});
          });
        }else if(that.$store.state.accountType == 'client' && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != ''  && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.user.user_id){
          await that.UpdateRequestRoomData({params:{'client_id':that.$store.state.currentUserData.login_master_id,'status':1,'userType': that.$store.state.accountType,'title': '','sort': 'DESC'}}).then(()=>{
            that.callChatRoomApi('getchatroom',{'request_type':'getchatroom','client_id':that.$store.state.currentUserData.login_master_id,'status':1,'userType': that.$store.state.accountType,'title': '','sort': 'DESC'});
          });
        }else if(that.$store.state.accountType == 'agency' && that.$store.state.currentUserData.login_master_id == that.$store.state.listAccount.company.login_master_id){
          await that.UpdateRequestRoomData({params:{'agency_id':that.$store.state.currentUserData.login_master_id,'status':1,'userType': that.$store.state.accountType,'title': '','sort': 'DESC'}}).then(()=>{
            that.callChatRoomApi('getchatroom',{'request_type':'getchatroom','agency_id':that.$store.state.currentUserData.login_master_id,'status':1,'userType': that.$store.state.accountType,'title': '','sort': 'DESC'});
          });
        }else if(that.$store.state.accountType == 'client' && that.$store.state.listAccount.user != null && that.$store.state.listAccount.user != '' && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.user.user_id ){
          await that.UpdateInvitationRequestRoomData({params:{'user_id':that.$store.state.currentUserData.permission.user_id,'member_permission_id': that.$store.state.currentUserData.permission.members_permission_id,'title': '','sort': 'DESC'}}).then(()=>{
            that.callChatRoomApi('getChatInvitation',{'request_type':'getChatInvitation','user_id':that.$store.state.currentUserData.permission.user_id,'member_permission_id': that.$store.state.currentUserData.permission.members_permission_id,'title': '','sort': 'DESC'});
          });
        }else if(that.$store.state.accountType == 'client' && that.$store.state.currentUserData.permission.user_id == that.$store.state.listAccount.qp_user.user_id){
          await that.UpdateInvitationRequestRoomData({params:{'user_id':that.$store.state.currentUserData.permission.user_id,'member_permission_id': that.$store.state.currentUserData.permission.members_permission_id,'title': '','sort': 'DESC'}}).then(()=>{
            that.callChatRoomApi('getChatInvitation',{'request_type':'getChatInvitation','user_id':that.$store.state.currentUserData.permission.user_id,'member_permission_id': that.$store.state.currentUserData.permission.members_permission_id,'title': '','sort': 'DESC'});
          });
        }else if(that.$store.state.accountType == 'agency' && that.$store.state.currentUserData.login_master_id != that.$store.state.listAccount.company.login_master_id){
          await that.UpdateInvitationRequestRoomData({params:{'user_id':that.$store.state.currentUserData.permission.user_id,'member_permission_id': that.$store.state.currentUserData.permission.members_permission_id,'title': that.search,'sort': that.sort}}).then(()=>{
            that.callChatRoomApi('getChatInvitation',{'request_type':'getChatInvitation','user_id':that.$store.state.currentUserData.permission.user_id,'member_permission_id': that.$store.state.currentUserData.permission.members_permission_id,'title': that.search,'sort': that.sort});
          });
        }
        await that.callChatData();
      }
    },
    
    // this fun is for to toggle search option in mobile view
    toggleMobileSearch() {
      this.isMobileSearchVisible = !this.isMobileSearchVisible;
    },
    // this fun is for to update user online offline status
    async updateOnlineOfflineStatus(){
      var res = await that.updateOnlineOffline();
      if(res){
        setTimeout(() => {
          if(this.getUserOnlinestatus == 1){
            that.updateOnlineOfflineStatus();
          }
        }, 1800000);
      }
    },
    // this fun is for to call chatroom api 
    async callChatData(){
      if(this.getcurrentUrl == 'chat' || this.getcurrentUrl == 'contractDetails' || this.getcurrentUrl == 'freelancercontractDetail' || this.getcurrentUrl == 'agencycontractDetail' || this.getcurrentUrl == 'messageSideBar' || this.getcurrentUrl == 'messageDetails'){        
        // console.log('getsocket',this.getmRequestData)
        // this.$socket.emit("getMessageofRoom", { request: this.getmRequestData });
        // // Listen for 'message' events
        // this.$socket.on('chatHistory', async (history) => {
        //   console.log('history',history)
        //   // await this.fetchChatfromSocket({params : history});
        // });
        // var res = await this.fetchChatData();
        // if(res == true){
        //   setTimeout(() => {
        //     this.callChatData();
        //   }, 3000);
        // }
      }
    },
    // this fun is for to call chat room socket
    async callChatRoomApi(_v, _request) {
      if (this.getcurrentUrl === "chat") {
          await this.fetchfromSocketChatRoomData({ params: [] });
          console.log('this.$socket', this.$socket);
          // Remove any previous listeners to avoid duplicate responses
          this.$socket.off("getChatRooms");
          console.log('getChatRooms-siteheader-socket-request', _request);
          // Emit the request to get chat rooms
          this.$socket.emit("getChatRooms", _request);
          // Add a listener for the 'getChatRooms' event
          this.$socket.on("getChatRooms", async (getChatRooms) => {
            console.log("getChatRooms-siteheader-socket", getChatRooms);
            // Uncomment and handle chat room data as needed
            if (getChatRooms.length > 0) {
              await this.fetchfromSocketChatRoomData({ params: getChatRooms });
              this.updateChatroomLoader({ params: false });
            } else {
              await this.fetchfromSocketChatRoomData({ params: [] });
              this.updateChatroomLoader({ params: false });
            }
          });
      }
    },

    // this fun is for to check tab permission for mobile responsive
    checkTabPermission(_data,_type){
      if(_type == 'agency' && _data.label =='Find Work'){
        return this.isPermissionForAgency('find-job');
      }else if(_type == 'agency' && _data.label =='My Jobs'){
        return this.isPermissionForAgency('all-Contracts');
      }else if(_type == 'agency' && _data.label =='Reports'){
        return this.isPermissionForAgency('transactionHistory');
      }else if(_type == 'client' && _data.label =='Talent'){
        return this.isPermissionForClient('talent');
      }else if(_type == 'agency' && _data.label =='Reports'){
        return this.isPermissionForAgency('transactionHistory');
      }
      return true;
    },

    toggleDropdown(item) {
      item.isDropdownOpen = !item.isDropdownOpen;
    },
    handleBlur(){
      setTimeout(() => {
        this.$store.dispatch("searchData", []);
      }, 500);
    },
    handleEnterKey(type) {
    // Increment the counter each time the Enter key is pressed
    this.enterKeyPressCount++;
      console.log('enterKeyPressCount',this.enterKeyPressCount);
    // If Enter has been pressed twice, perform the search and reset the counter
    if (this.enterKeyPressCount === 1) {
      this.openSearch(type, '');  // Trigger search
      this.enterKeyPressCount = 0;  // Reset the counter
    }
  },
    // this fun is for to open search page
    openSearch(_v,search) {
      console.log('search==',search);
      if(this.searchValue.trim() === ""){
        return false;
      }
      if(_v == 'mobile'){
        this.toggleMobileSearch();
      }
      var rName = 'Search';
      if (this.$store.state.accountType == 'client') {
        rName = 'clientSearch';
      } else if (this.$store.state.accountType == 'agency') {
        rName = 'agencySearch';
      }
      if(!search){
        search = {
          "search_word": this.searchValue,
          "search_type": 1,
          "search_table": '',
          "search_id": ''
        }
      }
      this.$store.dispatch("searchValue", search);
      this.saveSearch(search);
      this.$router.push({
        name: rName,
        params: { input: this.searchValue }
      }).catch(()=>{});
    },
    // this fun is for to get company count
    async getCompanyCount() {
      this.UpdateBodyScrollRole({params: false});
      // var res = await this.genericAPIPOSTRequest({
      var res = await this.genericAPIPOSTForNodeRequest({
        requestUrl: "user/getCompanyCount",
        params: { data: this.getLoginUserIdRequest() },
      });
      this.$store.dispatch("listAccount", res);
    },
    // this fun is for to get current user details
    async getCurrentUserDetails() {
      const loginData = JSON.parse(localStorage.getItem("loginUserData"));
      this.currentUser = loginData;
    },
    async  getSearchData(){
      this.enterKeyPressCount = 0;
      var res = await this.genericAPIPOSTForNodeRequest({
        requestUrl: "user/getSaveSearch",
        params: { search:this.searchValue },
      });
      this.$store.dispatch("searchData", res);
    },
    async saveSearch(search){
      var res = await this.genericAPIPOSTForNodeRequest({
        requestUrl: "user/saveSearch",
        params: { search:search },
      });

      console.log(res);
    }
  },
};
</script>

<style scoped>
.icon-wrapper-header {
  width: 18px;
  height: 18px;
  padding: 1px;
}

.icon-wrapper-header svg {
  width: 16px;
  height: 16px;
  color: #b0b0b0;
}

.account-dropdown-enter-active,
.account-dropdown-leave-active {
  transition: all 0.5s;
}

.account-dropdown-enter,
.account-dropdown-leave-to {
  opacity: 0;
  transform: translateY(-110px);
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
  transform: translateY(20px);
}

.list-enter,
.list-leave-to .list-leave-active {
  opacity: 0;
  transform: translateY(-30px);
}

.navbar-main {
  height: 80px;
}

@media only screen and (max-width: 1165px) {
  .navbar-main {
    height: 80px;
  }
}

.menu-items-list {
  /*padding-right: 250px;*/
  padding-right: 0px;
  margin-left: 10px;
}

@media only screen and (max-width: 1870px) {
  .menu-items-list {
    padding-right: 250px;
  }
}

@media only screen and (max-width: 1400px) {
  .menu-items-list {
    padding-right: 0px;
  }
}

@media only screen and (max-width: 1450px) {
  .menu-items-list {
    padding-right: 0px;
  }
}
@media only screen and (max-width: 1112px) {
  .menu-items-list {
    padding-right: 0px;
    margin-left: 0px;
  }
}
@media only screen and (max-width: 1269px) {
  .toggle-switch {
    display: none;
  }
}
.text-muted{color:#000!important;}
.text-grey {
  color: #979797 !important;
}
.fz-14 {
  font-size: 14px;
}
.fz-30 {
  font-size: 26px !important;
}
.fz-16 {
  font-size: 16px;
}
fw-600 {
  font-weight: 600;
}
.w-14 {
  width: 3rem;
}
.h-14 {
  height: 3rem;
}
.badge-theme {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  text-transform: capitalize;
  color: #ffffff !important;
  background: #f2613c;
  border-radius: 10px;
}
.text-decoration-none {
  text-decoration: none !important;
}
.menu {
  text-decoration: none !important;
  color: #000;
}
.menu:hover {
  color: #f2613c;
}
.active-profile {
  background-color: #FFF6F4 !important;
}

.header-search-wr{
  border: 1px solid #00000025;
  font-size: 15px;
  display: flex;
  padding: 12px 20px 12px 40px;
  width: 340px;
  justify-content: space-between;
  border-radius: 40px;
  transition: 0.2s all ease;
  background-color: #fff;
}
.header-search-wr.mobile{
  width: 100%;
}
.header-search-wr .profile-type-for-search{
  font-weight: 600;
  border-left: 1px solid #00000025;
  padding-left: 10px;
  margin-left: 10px;
}

.header-search-wr svg{
  width: 25px;
  fill: #00000075;
  left: 12px;
  top: 13px;

}
/* .header-search-wr select:focus{
  outline: 0 !important;
  border: 0 !important;
} */
.header-search-wr input{
  width: 100%;
}
.header-search-wr input,
.header-search-wr input:active,
.header-search-wr input:focus{
  border: 2px solid transparent !important;
  outline: 0 !important;
}

.reset-header-search{
  cursor: pointer;
  height: 10px;
  width: 10px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
  padding: 9px 9px;
  border: 2px solid #00000055;
  font-size: 12px;
  color: #00000055 !important;
  text-align: center;
  transition: 0.2s all ease;
}

.header-search-wr.typing,
.header-search-wr.focused{
  padding: 0;
  background: #E9E9E9;
  border: 0;
  padding-right: 10px;
  transition: 0.2s all ease;
}
.header-search-wr.typing span,
.header-search-wr.typing svg,
.header-search-wr.focused span,
.header-search-wr.focused svg{
  position: absolute;
}
span.reset-header-search.main-header {
    right: 23%;
}
.header-search-wr.typing span,
.header-search-wr.focused span{
  right: 26%;
    top: 15px;
    z-index: 10;
    cursor: pointer;
    background: #fff;
    
}

.header-search-wr.typing svg,
.header-search-wr.focused svg{
  top: 15px;
}

.header-search-wr.typing input,
.header-search-wr.typing input:active,
.header-search-wr.typing input:focus,
.header-search-wr.focusd input,
.header-search-wr.focusd input:active,
.header-search-wr.focusd input:focus{
  border: 2px solid #00000025 !important;
}
.header-search-wr.typing input:focus,
.header-search-wr.focused input:focus{
  transition: 0.2s all ease;
}
.header-search-wr.typing input,
.header-search-wr.focused input{
  border: 2px solid #00000025 !important;
  background: #fff;
  width: 100%;
  border-radius: 30px;
  padding:14px 50px 14px 40px;
  transition: 0.2s all ease;
}
.header-search-wr.typing .profile-type-for-search,
.header-search-wr.focused .profile-type-for-search{
  padding: 10px;
  border: 0;
  transition: 0.2s all ease;
  display: flex;
  margin: 0px;
  align-items: center;
  justify-content: center;
}
.auto-fill-data-wr{
  overflow-y: auto;
  background-color: #fff;
  position: absolute;
  width: 100%;
  left: 0;
  border: 1px solid #00000025;
  border-radius: 15px;
  transition: 0.2s all ease;
  opacity: 0;
  pointer-events: none;
  top: 0;
  height: fit-content;
}
.auto-fill-data-wr li{
  width: 100%;
  overflow-wrap: break-word;
  transition: 0.2s all ease;
  border-radius: 15px;
  padding: 5px 5px 5px 10px;
}
.auto-fill-data-wr li:hover{
  cursor: pointer;
  background: #00000015;
}
.header-search-wr.typing .auto-fill-data-wr,
.header-search-wr.focused .auto-fill-data-wr{
  top: 110%;
  opacity: 1;
  pointer-events: all;
}
.auto-fill-data-wr ul{
  margin-bottom: 0 !important;
  padding: 10px;
  padding-left: 10px !important;
}
.auto-fill-data-wr li{
  position: relative;
  padding: 5px 10px 5px 40px;
}
.header-search-wr.typing
.auto-fill-data-wr li svg,
.header-search-wr.focusd
.auto-fill-data-wr li svg{
  left: 10px;
  top: 6px;
}

.header-search-wr.typing.mobile span,
.header-search-wr.focused.mobile span {
    right: 14%;
    top: 19px;
}
@media only screen and (max-width: 567px) {
  .header-search-wr.typing.mobile span,
  .header-search-wr.focused.mobile span {
    right: 17%;
  } 
}
@media only screen and (max-width: 479px) {
.header-search-wr.typing.mobile span,
.header-search-wr.focused.mobile span{
        right: 21%;
 }
}
@media only screen and (max-width: 414px) {
.header-search-wr.typing.mobile span,
.header-search-wr.focused.mobile span{
        right: 23%;
 }
}
@media only screen and (max-width: 375px) {
.header-search-wr.typing.mobile span,
.header-search-wr.focused.mobile span{
        right: 26%;
 }
}

</style>